import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable()
export class PhpSessionInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      // Only add Authorization to template request
//    console.log('request : ', req);
    // if (req.url.indexOf(environment.templateurl) === 0) {
    //   let authorization = '';
    //   if (serviceuser.length !== 0 && servicepass.length !== 0) {
    //       // Build auth string
    //       authorization = btoa(serviceuser + ':' + servicepass);
    //   }
    //   req = req.clone({
    //       setHeaders: {
    //           Authorization: 'Basic ' + authorization
    //       },
    //   });
    //   console.log('PhpSessionInterceptor for BecareService');
    // }
    return next.handle(req).pipe(tap(evt => {
//      console.log('response', evt);
      if (evt instanceof HttpResponse) {
//        console.log('headers ', evt.headers);
//        console.log('All headers ', evt.headers.getAll('Set-Cookie'));
      }
    }));
  }
}
